var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:_vm.standardClass},[_vm._v(_vm._s(_vm.parsed.id))])
}
var staticRenderFns = []

export { render, staticRenderFns }